import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';
import {ShoppingService} from './shopping.service';

@Injectable()
export class FilterService {

  private _brand = new BehaviorSubject(null);
  get brand() {
    return this._brand.getValue();
  }
  set brand(brand: any) {
    this._brand.next(brand);
    this.localStorage.set('selected-brand', brand);
  }

  private _type = new BehaviorSubject(null);
  get type() {
    return this._type.getValue();
  }
  set type(type: any) {
    this._type.next(type);
    this.localStorage.set('selected-type', type);
  }

  constructor(private localStorage: LocalStorageService, private shoppingService: ShoppingService) {
    this.load();
  }

  public load() {
    const selectedBrand = this.localStorage.get('selected-brand');
    if (selectedBrand === null) {
      this.localStorage.set('selected-brand', null);
      this._brand.next(null);
    } else {
      this._brand.next(selectedBrand);
    }

    const selectedType = this.localStorage.get('selected-type');
    if (selectedType === null) {
      this.localStorage.set('selected-type', null);
      this._type.next(null);
    } else {
      this._type.next(selectedType);
    }
  }

  public clearBrand() {
    this.shoppingService.clear();
    this._brand.next(null);
    this.localStorage.remove('selected-brand');
    this._type.next(null);
    this.localStorage.remove('selected-type');
  }

  public clearType() {
    this.shoppingService.clear();
    this._type.next(null);
    this.localStorage.remove('selected-type');
  }
}


